function createThumbnail(tenant, fileName) {
  return new Promise((resolve, reject) => {
    fetch(
      `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
        process.env.VUE_APP_THUMBNAIL_SERVICE_URL
      }`,
      {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({
          tenant,
          fileName
        })
      }
    )
      .then(res => {
        return res.blob();
      })
      .then(function(blob) {
        resolve(blob);
      })
      .catch(e => {
        console.log(e);
        reject();
      });
  });
}

function resizeImage(data) {
  return new Promise((resolve, reject) => {
    const fetchUrl = data.width
      ? `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
          process.env.VUE_APP_IMAGE_SERVICE_URL
        }?width=${data.width}&tenant=${data.tenant}&fileName=${data.fileName}`
      : `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
          process.env.VUE_APP_IMAGE_SERVICE_URL
        }?tenant=${data.tenant}&fileName=${data.fileName}`;

    fetch(fetchUrl, {
      method: "post",
      body: data.formData
    })
      .then(res => {
        return res.text();
      })
      .then(function(text) {
        resolve(text);
      })
      .catch(e => {
        console.log(e);
        reject();
      });
  });
}

function ingestVideo(data) {
  return new Promise((resolve, reject) => {
    fetch(
      `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
        process.env.VUE_APP_VIDEO_INGEST_URL
      }`,
      {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({
          fileName: data.fileName,
          tenant: data.tenant
        })
      }
    )
      .then(res => {
        if (res.ok) {
          return resolve();
        }
        reject();
      })
      .catch(e => {
        console.log(e);
        reject();
      });
  });
}

function deleteVideo(fileName) {
  return new Promise((resolve, reject) => {
    fetch(
      `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
        process.env.VUE_APP_VIDEO_INGEST_URL
      }`,
      {
        method: "delete",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({
          fileName
        })
      }
    )
      .then(res => {
        if (res.ok) {
          return resolve();
        }
        reject();
      })
      .catch(e => {
        console.log(e);
        reject();
      });
  });
}

export { createThumbnail, resizeImage, ingestVideo, deleteVideo };
